import React from "react";

function SecondCareers() {
  return (
    <div className="bg-midBlue text-white font-sans py-[80px]">
      <div className="w-11/12 sm:w-10/12 xl:w-8/12 max-w-6xl mx-auto text-24 leading-7">
        <div className="sm:w-11/12 mx-auto">
          <h2 className="text-40 leading-[50px] mb-10 text-center font-medium">
            Account Manager
          </h2>
          <p className="font-light text-center mb-20 leading-7">
            Tomedes is a leading global translation company that provides
            services to major Fortune 500 companies.
          </p>
          <p className="mb-4">Seeking |</p>
          <p className="font-light mb-9">
            Full time Sales Account Manager for an international translation
            company serving thousands of clients worldwide (work from home
            position): As an account manager, you will work with companies all
            over the world. You will be responsible for account success,
            retention, negotiation and business development (expanding existing
            partnerships and establish new partnerships).
          </p>
        </div>
      </div>
      <div className="w-11/12 sm:w-10/12 xl:w-9/12 max-w-6xl mx-auto text-24 leading-7">
        <p className="text-24 left-7 mb-10 pt-[52px]">
          Responsibilities Include |
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-7 text-[21px] font-light">
          <div className="bg-black rounded-lg shadow-lg px-7 py-4 flex items-center justify-center">
            <p className="text-center">
              Contacting current and past clients via phone
            </p>
          </div>
          <div className="bg-black rounded-lg shadow-lg px-7 py-4 flex items-center justify-center">
            <p className="text-center">Following up with clients via email</p>
          </div>
          <div className="bg-black rounded-lg shadow-lg px-7 py-4 flex items-center justify-center">
            <p className="text-center">
              Being personable and proactive in order to close the sales deal
            </p>
          </div>
        </div>
      </div>
      <div className="w-11/12 sm:w-10/12 xl:w-8/12 max-w-6xl mx-auto text-24 leading-7 my-20">
        <div className="sm:w-11/12 mx-auto">
          <p className="text-24 left-7 mb-10 pt-[52px]">Requirements |</p>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-7 text-[21px] font-light">
            <div className="flex gap-9 bg-black rounded-lg shadow-lg px-6 py-3 items-center">
              <img
                src="https://skins.tomedes.com/frontend/images/careers_icons/fluent_english.svg"
                alt=""
                className="w-16"
              />
              <p>Fluent/mother tongue level English speaker.</p>
            </div>
            <div className="flex gap-9 bg-black rounded-lg shadow-lg px-6 py-3 items-center">
              <img
                src="https://skins.tomedes.com/frontend/images/careers_icons/professional_english.svg"
                alt=""
                className="w-16"
              />
              <p>High professional level written English.</p>
            </div>
            <div className="flex gap-9 bg-black rounded-lg shadow-lg px-6 py-3 items-center">
              <img
                src="https://skins.tomedes.com/frontend/images/careers_icons/3plus.svg"
                alt=""
                className="w-16"
              />
              <p>
                3+ years prior experience in phone sales in the native English
                speaking market.
              </p>
            </div>
            <div className="flex gap-9 bg-black rounded-lg shadow-lg px-6 py-3 items-center">
              <img
                src="https://skins.tomedes.com/frontend/images/careers_icons/creative.svg"
                alt=""
                className="w-16"
              />
              <p>Creative, self-motivated, analytical, and diligent</p>
            </div>
            <div className="flex gap-9 bg-black rounded-lg shadow-lg px-6 py-3 items-center">
              <img
                src="https://skins.tomedes.com/frontend/images/careers_icons/relationship.svg"
                alt=""
                className="w-16"
              />
              <p>Articulate and sales/relationship oriented</p>
            </div>
            <div className="flex gap-9 bg-black rounded-lg shadow-lg px-6 py-3 items-center">
              <img
                src="https://skins.tomedes.com/frontend/images/careers_icons/working_with_laptop.svg"
                alt=""
                className="w-16"
              />
              <p>Experience working with computers</p>
            </div>
            <div className="flex gap-9 bg-black rounded-lg shadow-lg px-6 py-3 items-center">
              <img
                src="https://skins.tomedes.com/frontend/images/careers_icons/teamwork.svg"
                alt=""
                className="w-16"
              />
              <p>Able to work both independently and part of a team</p>
            </div>
          </div>
          <p className="text-24 left-7 mb-10 pt-[90px]">Advantages |</p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-7 text-[21px] font-light mb-16">
            <div className="bg-black rounded-lg shadow-lg px-7 py-5 flex items-center justify-center">
              <p className="text-center">Proficiency with CRM</p>
            </div>
            <div className="bg-black rounded-lg shadow-lg px-7 py-5 flex items-center justify-center">
              <p className="text-center">Experience in B2B sales</p>
            </div>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-7">
            <div className="flex gap-10 items-center">
              <img
                src="https://skins.tomedes.com/frontend/images/careers_icons/time.svg"
                alt=""
                className="w-16"
              />
              <div>
                <p className="text-24 leading-7 mb-2">Hours</p>
                <p className="text-[21px] font-light">
                  Monday- Friday, flexible shifts
                </p>
              </div>
            </div>
            <div className="flex gap-10 items-center">
              <img
                src="https://skins.tomedes.com/frontend/images/careers_icons/location.svg"
                alt=""
                className="w-16"
              />
              <div>
                <p className="text-24 leading-7 mb-2">Location</p>
                <p className="text-[21px] font-light">
                  Beaverton, Oregon (USA) Manila, Philippines, Tel Aviv, Israel
                </p>
              </div>
            </div>
          </div>
          <p className="text-24 leading-7 font-light mt-6 text-center sm:text-left">
            Please send CVs to hr@tomedes.com
          </p>
        </div>
      </div>
    </div>
  );
}

export default SecondCareers;
